var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrangeDiagonals(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1366 440",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:#f8971f;}.a{opacity:0.12;}.b{opacity:0.239;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1366 1208) rotate(180)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M0,440,783,0H0Z",
    transform: "translate(0 768)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M783,440,0,0H783Z",
    transform: "translate(583 768)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M0,388,683,0H0Z",
    transform: "translate(0 768)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M683,388,0,0H683Z",
    transform: "translate(683 768)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrangeDiagonals);
export default __webpack_public_path__ + "static/media/orange_diagonals.ce01a7022215ff6fe7166fc5cab9baff.svg";
export { ForwardRef as ReactComponent };